import { useState, useEffect } from 'react';
import useAuth from '../../auth_services/useAuth';
import useAxiosPrivate from '../../auth_services/useAxiosPrivate';
import { useNavigate } from 'react-router-dom';
//material
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import MenuItem from '@mui/material/MenuItem';
import Grid from '@mui/material/Grid';
import TextField from '@mui/material/TextField';
import IconButton from '@mui/material/IconButton';
import Tooltip from '@mui/material/Tooltip';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';
//material
import Clear from '@mui/icons-material/Clear';
import AlertPopup from '../../components/modal/AlertPopup';
import FrmValidation from '../../validation/frmValidateCheck';
import '../../css/style.css';

const MerchantPaymentinfoForm = (props) => {
    const [validateVal, setValidateVal] = useState({});     // Set erro value from backend validate

    // Call navigate
    const navigate = useNavigate();
    const axiosPrivate = useAxiosPrivate();

    // Modal open
    const [alertPopup, setAlertPopup] = useState({ open: false });      // Set val modal alert popup

    const [btnLoading, setBtnLoading] = useState(false);

    // Set val
    const [form, setForm] = useState({
        provider: 'bcel',
        qr_type: '',
        mcid: '',
        shop_code: '',
        mcc: '',
        id: '',
        username: '',
        password: '',
        merchant_name: '',
        merchant_name_org: '',
        mc_eng: '',
        account: ''
    });

    const onFormChange = (e) => {
        let formUpdate = {};
        formUpdate = { [e.target.name]: e.target.value };
        setForm(form => ({
            ...form,
            ...formUpdate
        }));
    }

    const onFormClear = () => {
        setForm({
            provider: 'bcel',
            qr_type: '',
            mcid: '',
            shop_code: '',
            mcc: '',
            id: '',
            username: '',
            password: '',
            merchant_name: '',
            mc_eng: '',
            account: ''
        });
    }

    useEffect(() => {
        if (props.open == true) {
            //getMerchant();
            setBtnLoading(false);
            setValidateVal({});

            if (props.status == 'edit') {
                setForm(props.editval);
            } else if (props.status == 'add') {
                onFormClear();
            }
        }
    }, [props]);

    const [merchantVal, setMerchantVal] = useState([]);
    const getMerchant = async () => {
        try {
            const data = {}
            const response = await axiosPrivate.get('merchant_info/midmain', data);
            setMerchantVal(response.data);
        } catch (error) {
            console.log("error", error);
            navigate("/login");
        }
    }

    // Add new
    const AddNew = async () => {
        try {
            // Call API for add new
            setBtnLoading(true);
            let val = {
                provider: form.provider,
                qr_type: form.qr_type,
                mcid: form.mcid,
                shop_code: form.shop_code,
                mcc: form.mcc,
                id: form.id,
                username: form.username,
                password: form.password,
                merchant_name: form.merchant_name,
                mc_eng: form.mc_eng,
                account: form.account,
                maker: useAuth.userName(),
                last_update_by: useAuth.userName()
            }

            const response = await axiosPrivate.post('merchant_paymentinfo/add', val);

            setBtnLoading(true);

            // Set val to parent
            props.loadVal(response.data);

            // Set alert popup props
            setAlertPopup({
                open: true,
                status: 'primary',
                message: 'ເພີ່ມຂໍ້ມູນສໍາເລັດ',
                action: 'add'
            });

            //onFormClear();

            // Close add form modal
            props.close();

        } catch (error) {
            setBtnLoading(false);

            const err = error.response.data;

            // Set from validate
            setValidateVal(error.response.data);
        }

    }

    // Edit Merchant info
    const Edit = async () => {
        try {
            setBtnLoading(true);

            let val = form;
            val.iid = props.editval.iid;
            val.mcid_org = props.editval.mcid;
            const response = await axiosPrivate.post('merchant_paymentinfo/update', val);

            setBtnLoading(false);

            // Set value
            props.loadVal(response.data);
            props.close();

            setAlertPopup({
                open: true,
                status: 'primary',
                message: 'ແກ້ໄຂຂໍ້ມູນສໍາເລັດ',
                action: 'edit'
            });

        } catch (error) {
            setBtnLoading(false);

            // Check login authen
            if (error.response?.status == '401') {
                navigate('/login');
            } else {
                setValidateVal(error.response.data);
            }
        }
    }

    return (
        <>
            <Dialog
                open={props.open}
                scroll='paper'
                aria-labelledby="scroll-dialog-title"
                aria-describedby="scroll-dialog-description"
                sx={{ overflowY: 'none' }}
                fullWidth
                maxWidth='sm'
            >
                <DialogTitle id="scroll-dialog-title" sx={{ fontWeight: 'bold', backgroundColor: 'background.dialog' }}>
                    {(props.status == 'add') ? 'ເພີ່ມຂໍ້ມູນຮ້ານເຊື່ອມ payment' : 'ເເກ້ໄຂຂໍ້ມູນຮ້ານຄ້າເຊື່ອມ payment'}
                </DialogTitle>
                <DialogActions sx={{ mt: '-60px' }}>
                    <Tooltip title='ປິດ'>
                        <IconButton
                            aria-label="Close"
                            onClick={() => {
                                //onFormClear();
                                props.close();
                            }}
                        >
                            <Clear />
                        </IconButton>
                    </Tooltip>
                </DialogActions>
                <DialogContent dividers={'body' === 'paper'} sx={{ backgroundColor: 'background.dialog' }}>
                    <Box sx={{ padding: '0px' }}>
                        <Grid container spacing={2}>
                            <Grid size={{ xs: 12 }}>
                                <Grid container spacing={1.5}>
                                    <Grid size={{ xs: 6 }}>
                                        <TextField
                                            label="Payment provider"
                                            name="provider"
                                            onChange={onFormChange}
                                            value={form.provider}
                                            required
                                            error={FrmValidation.error(validateVal, "provider")}
                                            helperText={FrmValidation.msg(validateVal, "provider")}
                                            size="small"
                                            variant="outlined"
                                            fullWidth
                                        />
                                    </Grid>
                                    <Grid size={{ xs: 6 }}>
                                        <TextField
                                            label="QR type"
                                            variant='outlined'
                                            select
                                            name="qr_type"
                                            value={form.qr_type}
                                            onChange={onFormChange}
                                            required
                                            size="small"
                                            fullWidth
                                        >
                                            <MenuItem key='1' value='api'>API</MenuItem>
                                            <MenuItem key='2' value='ecom'>ECOM</MenuItem>
                                        </TextField>
                                    </Grid>
                                    <Grid size={{ xs: 12 }}>
                                        <TextField
                                            label="mcid"
                                            name="mcid"
                                            onChange={onFormChange}
                                            value={form.mcid}
                                            required
                                            error={FrmValidation.error(validateVal, "mcid")}
                                            helperText={FrmValidation.msg(validateVal, "mcid")}
                                            size="small"
                                            variant="outlined"
                                            fullWidth
                                        />
                                    </Grid>
                                    <Grid size={{ xs: 12 }}>
                                        <TextField
                                            label="Shop code"
                                            name="shop_code"
                                            onChange={onFormChange}
                                            required
                                            value={form.shop_code}
                                            error={FrmValidation.error(validateVal, "shop_code")}
                                            helperText={FrmValidation.msg(validateVal, "shop_code")}
                                            size="small"
                                            variant="outlined"
                                            fullWidth
                                        />
                                    </Grid>
                                    <Grid size={{ xs: 6 }}>
                                        <TextField
                                            label="MCC"
                                            name="mcc"
                                            onChange={onFormChange}
                                            required
                                            value={form.mcc}
                                            error={FrmValidation.error(validateVal, "mcc")}
                                            helperText={FrmValidation.msg(validateVal, "mcc")}
                                            size="small"
                                            variant="outlined"
                                            fullWidth
                                        />
                                    </Grid>
                                    <Grid size={{ xs: 6 }}>
                                        <TextField
                                            label="ID"
                                            name="id"
                                            onChange={onFormChange}
                                            value={form.id}
                                            error={FrmValidation.error(validateVal, "id")}
                                            helperText={FrmValidation.msg(validateVal, "id")}
                                            size="small"
                                            variant="outlined"
                                            fullWidth
                                        />
                                    </Grid>
                                    <Grid size={{ xs: 12 }}>
                                        <TextField
                                            label="Username"
                                            name="username"
                                            onChange={onFormChange}
                                            value={form.username}
                                            required
                                            error={FrmValidation.error(validateVal, "username")}
                                            helperText={FrmValidation.msg(validateVal, "username")}
                                            size="small"
                                            variant="outlined"
                                            fullWidth
                                        />
                                    </Grid>
                                    <Grid size={{ xs: 12 }}>
                                        <TextField
                                            label="Password"
                                            name="password"
                                            onChange={onFormChange}
                                            value={form.password}
                                            required
                                            error={FrmValidation.error(validateVal, "password")}
                                            helperText={FrmValidation.msg(validateVal, "password")}
                                            size="small"
                                            variant="outlined"
                                            fullWidth
                                        />
                                    </Grid>
                                    <Grid size={{ xs: 12 }}>
                                        <TextField
                                            label="Merchant name"
                                            name="merchant_name"
                                            onChange={onFormChange}
                                            value={form.merchant_name}
                                            required
                                            error={FrmValidation.error(validateVal, "merchant_name")}
                                            helperText={FrmValidation.msg(validateVal, "merchant_name")}
                                            size="small"
                                            variant="outlined"
                                            fullWidth
                                        />
                                    </Grid>
                                    <Grid size={{ xs: 12 }}>
                                        <TextField
                                            label="Merchant name eng"
                                            name="mc_eng"
                                            onChange={onFormChange}
                                            value={form.mc_eng}
                                            error={FrmValidation.error(validateVal, "mc_eng")}
                                            helperText={FrmValidation.msg(validateVal, "mc_eng")}
                                            size="small"
                                            variant="outlined"
                                            fullWidth
                                        />
                                    </Grid>
                                    <Grid size={{ xs: 12 }}>
                                        <TextField
                                            label="Account"
                                            name="account"
                                            onChange={onFormChange}
                                            value={form.account}
                                            error={FrmValidation.error(validateVal, "account")}
                                            helperText={FrmValidation.msg(validateVal, "account")}
                                            size="small"
                                            variant="outlined"
                                            fullWidth
                                        />
                                    </Grid>
                                </Grid>
                            </Grid>

                            <Grid size={{ sm: 6 }} sx={{ display: { xs: 'none', sm: 'flex' } }}>&nbsp;</Grid>
                            <Grid size={{ xs: 6, sm: 3 }}>
                                {
                                    props.status == 'add' ? (
                                        <Button
                                            variant="contained"
                                            className="font-family btn-manage"
                                            onClick={AddNew}
                                            fullWidth
                                        >
                                            ບັນທຶກ
                                        </Button>
                                    ) : (
                                        <Button
                                            variant="contained"
                                            className="font-family btn-manage"
                                            onClick={Edit}
                                            fullWidth
                                            loading={btnLoading}
                                            loadingPosition="start"
                                        >
                                            ບັນທຶກ
                                        </Button>
                                    )
                                }
                            </Grid>
                            <Grid size={{ xs: 6, sm: 3 }}>
                                <Button
                                    variant="outlined"
                                    className="font-family btn-manage"
                                    onClick={() => {
                                        //onFormClear();
                                        props.close();
                                    }}
                                    fullWidth
                                >
                                    ຍົກເລິກ
                                </Button>
                            </Grid>
                        </Grid>
                    </Box >
                </DialogContent >
            </Dialog >

            {/***  Modal popup alert*/}
            < AlertPopup
                width='400px'
                props={alertPopup}
                func={() => {
                    alertPopup.btn.btnAction.func();
                    alertPopup.btn.btnCancel.func();
                }}
            />
        </>
    )
}

export default MerchantPaymentinfoForm